import React, { FC } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import { Modal as AskBeforeLoseChangesModal } from 'components/Modals/AskBeforeLeave';
import BrandSelect from 'components/Form/BrandSelect';
import CategoryModal from 'components/Modals/CategoryModal';
import ItemModal from 'components/Modals/ItemModal';
import ModifierModal from 'components/Modals/ModifierModal';
import BlockedMessage from 'components/Loaders/BlockedMessage';
import DropDownButton from 'components/DropDownButton';
import Items from './Items';
import ModifierSets from './ModifierSets';
import { Container, Header, Tabs, Tab, Filters, Button } from './styles';
import useConnect from './connect';

const MenuManagment: FC = () => {
  const {
    selectedBrandId,
    handleSelectBrand,
    data,
    isLoading,
    handleUpdate,
    askBeforeLeaveRouteModal,
    askBeforeChangeBrandModal,
    handleExportFinal,
    handleExportInstructions,
    exportLoading,
  } = useConnect();

  const isProcessing = data.status === 'PROCESSING';
  return (
    <>
      <Container>
        <AskBeforeLoseChangesModal
          isPublishing={askBeforeLeaveRouteModal.isPublishing}
          open={askBeforeLeaveRouteModal.modalIsOpen}
          onCancel={askBeforeLeaveRouteModal.handleCancel}
          onDiscard={askBeforeLeaveRouteModal.handleDiscard}
          onPublish={askBeforeLeaveRouteModal.handleConfirm}
        />
        <AskBeforeLoseChangesModal
          isPublishing={askBeforeChangeBrandModal.isPublishing}
          open={askBeforeChangeBrandModal.modalIsOpen}
          onCancel={askBeforeChangeBrandModal.handleCancel}
          onDiscard={askBeforeChangeBrandModal.handleDiscard}
          onPublish={askBeforeChangeBrandModal.handleConfirm}
        />
        <Header>
          <Tabs>
            <Tab label="Items" to="/menu-manager/items" />
            <Tab label="Modifier Sets" to="/menu-manager/modifier-sets" />
          </Tabs>

          <Filters>
            <BrandSelect
              setSelectedId={handleSelectBrand}
              value={selectedBrandId}
              allowAllOption={false}
            />
            <Button
              color="secondary"
              disabled={isLoading || isProcessing || !data.hasChanges}
              onClick={handleUpdate}
            >
              Publish
            </Button>
            <DropDownButton
              title="Export"
              disabled={exportLoading && !!selectedBrandId}
              buttons={[
                {
                  label: 'Export Creative Menu',
                  handler: handleExportFinal,
                },
                {
                  label: 'Export Standard Menu',
                  handler: handleExportInstructions,
                },
              ]}
            />
          </Filters>
        </Header>
        {isProcessing && <BlockedMessage />}
        <Switch>
          <Route exact path="/menu-manager/items">
            <Items
              isLoading={isLoading}
              brandId={selectedBrandId}
              categories={data.structure.length}
              isProcessing={isProcessing}
            />
          </Route>
          <Route exact path="/menu-manager/modifier-sets">
            <ModifierSets
              isLoading={isLoading}
              brandId={selectedBrandId}
              modifierGroups={data.modifierGroups}
              isProcessing={isProcessing}
            />
          </Route>
          <Redirect to="/menu-manager/items" />
        </Switch>
      </Container>
      {data.modal?.category && selectedBrandId !== '' && (
        <CategoryModal
          brandId={selectedBrandId}
          previousData={data.modal.category.previousData}
          isProcessing={isProcessing}
        />
      )}
      {data.modal?.item && selectedBrandId !== '' && (
        <ItemModal
          brandId={selectedBrandId}
          menuId={data.id}
          previousData={data.modal.item.previousData}
          categoryOptions={data.modal.item.categoryOptions}
          modifiers={data.modifierGroups}
          items={data.items}
          isProcessing={isProcessing}
        />
      )}
      {data.modal?.modifier && selectedBrandId !== '' && (
        <ModifierModal
          brandId={selectedBrandId}
          previousData={data.modal.modifier.previousData}
          items={data.items}
          isProcessing={isProcessing}
        />
      )}
    </>
  );
};

export default MenuManagment;
